import { sparkleOnDarkIcon } from '@/assets/icons';
import { AssetIcon, type AssetIconProps } from './AssetIcon';

export type SparkleOnDarkIconProps = Omit<AssetIconProps, 'src' | 'alt'>;

/** White dual-star sparkle for purple / dark backgrounds (login hero, etc.). */
export function SparkleOnDarkIcon({ size = 28, className, ...props }: SparkleOnDarkIconProps) {
  return (
    <AssetIcon
      src={sparkleOnDarkIcon}
      size={size}
      className={className}
      alt=""
      aria-hidden
      {...props}
    />
  );
}
